'use strict'

import React from 'react'

import './HeaderArrow.less'

const HeaderArrow = ({children, onClick}) => {
  return <div className='accordion-panel-header-arrow' onClick={onClick}>
    {children}
    <span className='accordion-arrow' />
  </div>
}

export default HeaderArrow



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Accordion/HeaderArrow/index.js